var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContactUsTopic, sendApiV1Contact, useComputedConfig, } from 'common';
import { FundInput } from './fund-input';
import { Button, Col } from '../../atoms';
import { memo, useCallback, useMemo, useState } from 'react';
import { AmountInput } from './amount-input';
import { MessageInput } from './message-input';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Callout } from '../../molecules';
import { RelationshipManagerCard } from '../../organisms/relationship-manager-card';
import { ModalHeader } from '../modal';
import { useBreakpoints } from '../../hooks';
export const FundContactForm = memo(({ accessToken, fundCode: initialFundCode, funds = [], identity, manager, mode, onBeforeSubmit, onClose, }) => {
    var _a, _b, _c;
    // State
    const [fundCode, setFundCode] = useState(initialFundCode !== null && initialFundCode !== void 0 ? initialFundCode : null);
    const [amount, setAmount] = useState(null);
    const [message, setMessage] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [isSuccessful, setSuccessful] = useState(null);
    // Vars
    const isDisabled = !amount || !fundCode;
    const { breakpoints } = useBreakpoints();
    const selectedFund = useMemo(() => {
        var _a;
        if (!fundCode) {
            return null;
        }
        return (_a = funds.find(f => f.code === fundCode)) !== null && _a !== void 0 ? _a : null;
    }, [fundCode, funds]);
    const { apiUrl } = useComputedConfig();
    // Handlers
    const handleChangeFund = useCallback((value) => {
        var _a;
        setFundCode((_a = value === null || value === void 0 ? void 0 : value.code) !== null && _a !== void 0 ? _a : null);
    }, []);
    const handlePressBack = useCallback(() => {
        setSuccessful(null);
    }, []);
    const handleSubmit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (amount && selectedFund) {
            setLoading(true);
            try {
                onBeforeSubmit === null || onBeforeSubmit === void 0 ? void 0 : onBeforeSubmit();
                const content = `${mode === 'redeem' ? 'Redemption request' : 'Subscription request'}

Fund: ${selectedFund.name}
Amount: ${amount.toString()} ${(_b = (_a = selectedFund === null || selectedFund === void 0 ? void 0 : selectedFund.data) === null || _a === void 0 ? void 0 : _a.fundMarketDetail) === null || _b === void 0 ? void 0 : _b.currency}

Customer: ${identity.firstName}  ${identity.lastName}
Email: ${identity.email}
${message ? '\n\nMessage:\n' + message : ''}`;
                const res = yield sendApiV1Contact(window.apiTarget || apiUrl, {
                    name: `${identity.firstName} ${identity.lastName}`,
                    email: identity.email,
                    content,
                    recaptchaToken: null, // Recaptcha is not used when logged in
                    topic: ContactUsTopic.XBTO_FUNDS,
                    company: null,
                    country: null,
                    website: null,
                }, {
                    Authorization: `Bearer ${accessToken}`,
                });
                setSuccessful(res.isSuccessful);
            }
            catch (_c) {
                setSuccessful(false);
            }
            finally {
                setLoading(false);
            }
        }
    }), [
        amount,
        apiUrl,
        identity.email,
        identity.firstName,
        identity.lastName,
        message,
        onBeforeSubmit,
        selectedFund,
    ]);
    // Render
    const relationshipManagerEl = manager ? (_jsx(RelationshipManagerCard, Object.assign({}, manager))) : null;
    if (isSuccessful === true) {
        return (_jsxs(Col, { style: $.containerFeedback, children: [_jsx(Callout, { icon: "Check", title: "Message submitted", message: "Your message has been sent to you relationship manager and they will be in touch to discuss further, if you need any help please contact them using the details below.", variant: "tertiary" }), relationshipManagerEl, _jsx(Button, { label: "Close", variant: "tertiary", onPress: onClose })] }));
    }
    if (isSuccessful === false) {
        return (_jsxs(Col, { style: $.containerFeedback, children: [_jsx(Callout, { icon: "PriorityHigh", title: "Message could not be sent", message: "We could not send your message at this time, please try again or reach out to your relationship manager via phone.", variant: "tertiary" }), relationshipManagerEl, _jsx(Button, { label: "Back", variant: "tertiary", onPress: handlePressBack })] }));
    }
    const description = mode === 'redeem'
        ? "Let your relationship manager know how much you are willing to redeem, and he'll get back to you quickly to guide you through the redemption process"
        : "Let your relationship manager know how much you're interested to invest, and he'll get back to you quickly to guide you through the subscription and payment process";
    const amountInputLabel = mode === 'redeem'
        ? 'How much would you be willing to redeem?'
        : 'How much would you be willing to invest?';
    return (_jsxs(Col, { children: [_jsx(ModalHeader, { title: "Contact your relationship manager", subtitle: description }), _jsxs(Col, { style: $.content, children: [!initialFundCode && !!funds.length && (_jsx(FundInput, { valueId: fundCode, values: funds, onChange: handleChangeFund })), _jsx(AmountInput, { label: amountInputLabel, value: amount, onChange: setAmount, displayCode: (_c = (_b = (_a = selectedFund === null || selectedFund === void 0 ? void 0 : selectedFund.data) === null || _a === void 0 ? void 0 : _a.fundMarketDetail) === null || _b === void 0 ? void 0 : _b.currency) !== null && _c !== void 0 ? _c : null }), _jsx(MessageInput, { value: message, onChange: setMessage }), !!relationshipManagerEl && (_jsx(Col, { mt: breakpoints.XS ? '2' : '6', children: relationshipManagerEl })), _jsx(Button, { label: "Send", variant: "primary", onPress: handleSubmit, disabled: isDisabled || isLoading })] })] }));
});
const $ = StyleSheet.create({
    content: {
        gap: theme.spacing['6'],
    },
    containerFeedback: {
        gap: theme.spacing['8'],
    },
});
